import { render, staticRenderFns } from "./TicketsAndActivitiesView.vue?vue&type=template&id=4bc5cd6e&scoped=true"
import script from "./TicketsAndActivitiesView.vue?vue&type=script&lang=js"
export * from "./TicketsAndActivitiesView.vue?vue&type=script&lang=js"
import style0 from "./TicketsAndActivitiesView.vue?vue&type=style&index=0&id=4bc5cd6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5cd6e",
  null
  
)

export default component.exports